<template>
  <div class="product-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input v-model="searchParams.prodNameLike" :placeholder="$t('goods.productNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%" class="margin-top">
      <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
      <el-table-column prop="productId" label="商品ID" align="center"></el-table-column>
      <el-table-column prop="categoryName" label="商品分组" align="center"></el-table-column>
      <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
      <el-table-column prop="shName" label="仓库" align="center"></el-table-column>
      <el-table-column prop="sales" label="销量" align="center"></el-table-column>
      <el-table-column prop="stock" label="库存" align="center"></el-table-column>
      <el-table-column prop="defaultSpecValue.price" label="价格" align="center"></el-table-column>
      <el-table-column prop="sort" label="排序" align="center"></el-table-column>
      <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" align="right">
        <template #default="scope">
          <el-button size="small" @click="handleViewDetail(scope.row)">
            {{ $t('common.view') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { getProductList } from '@/api/goods/goodsApi'

export default {
  name: 'AShopDetailProduct',
  data() {
    return {
      searchParams: {
        prodNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {

  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await getProductList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleViewDetail(product) {
      this.$emit('view-detail', product)
    }
  }
}
</script>

<style scoped>
.product-container {
}

.search-row {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}
</style>